import { render } from "./Protocols.vue?vue&type=template&id=8f57bac0&scoped=true"
import script from "./Protocols.vue?vue&type=script&lang=js"
export * from "./Protocols.vue?vue&type=script&lang=js"

import "./Protocols.vue?vue&type=style&index=0&id=8f57bac0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f57bac0"]])

export default __exports__